<template>
  <div class="view contentBody"> 
    <div class="search_wrap">
      <el-form :inline="true" :model="listData" class="form-inline">
        <el-form-item label="合伙人">
          <el-select class="whd-select" clearable v-model="listData.partner_id" placeholder="全部" size="small">
            <el-option
              v-for="(item,index) in partner_list"
              :value="item.value"
              :label="item.name"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> 
        <el-form-item label="变动类型">
          <el-select class="whd-select" clearable v-model="listData.type" placeholder="全部" size="small">
            <el-option
              v-for="(item,index) in items"
              :value="item.value"
              :label="item.label"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="变动时间">
          <el-date-picker
            v-model="listData.create_time"
            type="date"
            size="small"
            placeholder="请选择时间">
          </el-date-picker>
        </el-form-item> 
        <el-form-item>
        <el-button type="primary" size="small" @click="InitFn" icon="el-icon-search"></el-button>
        </el-form-item>
      </el-form>
    </div>
   
    <div class="table_wrap">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="合伙人名称"></el-table-column>
        <el-table-column prop="type_text" label="变动类型"></el-table-column> 
        <el-table-column prop="money" label="变动金额"></el-table-column>
        <el-table-column prop="after_balance" label="剩余股本"></el-table-column>
        <el-table-column prop="create_time_text" label="变动时间"></el-table-column>
        <el-table-column prop="remark" label="事件概况"></el-table-column>

      </el-table>       
    </div>  
    <div class="pag_wrap">
      <el-pagination
        background
        :page-size="page.page_size"
        :current-page="page.current_page"
        layout="total, prev, pager, next"
        :page-count="page.total_pages"
        :total="page.total"
        @current-change="pageIndexChange"
      ></el-pagination>
    </div>  
   
  </div> 
</template>

<script>

import { pagination } from "@/util/util.js";
import api from "@/api.js";
export default {
  name: "rugu", 
  data() {
    return {  
      items: [{
          value: 0,
          label: '全部'
        }, {
          value: 1,
          label: '充值'
        }, {
          value: 2,
          label: '消费'
        },],
      publisher_list:[],
      tableData: [],
      partner_list: [],
      page: {
        current_page: pagination.pageIndex,
        page_size: pagination.pageSize,
        total_rows: pagination.total_rows
      },  
      listData: {
        name: '',
        type: '',
        create_time: '',
        partner_id:''
      }    
    }
  },
  created() {
    this.InitFn();
  },
  methods: {
    InitFn() {
      this.listData.page = this.page.current_page;
      this.axios
        .post(api.partner_ruguLog, this.listData)
        .then(response => {
          if (response.data.code == 0) {
            this.tableData = response.data.result.lists;
            this.partner_list = response.data.result.partner_list;
            this.page.total = response.data.page.total_rows//总条数

          } 
        })
        .catch(() => {});      
    },
    pageIndexChange(pageindex) {
      this.page.current_page = pageindex;
      this.InitFn();
    },
   
    
  }
}
</script>
